module.exports = __webpack_public_path__ + "img/NikunjBrokinglogo.958e6148.png";